export default {
  saleLeads: [],
  saleLead: undefined,
};
